import { useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

const useDraftSubmission = (submissionId) => {
  const [draftData, setDraftData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    // If invalid submissionId, don't do anything
    if (!submissionId || typeof submissionId !== "string") {
      console.warn("Invalid or missing submissionId provided.");
      setDraftData(null);
      setError("Invalid submission ID.");
      setNotFound(false);
      setLoading(false);
      return;
    }

    // Valid submissionId, set loading state
    setDraftData(null);
    setError(null);
    setNotFound(false);
    setLoading(true);

    const draftDocRef = doc(db, "submissions", submissionId);

    const unsubscribe = onSnapshot(
      draftDocRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          setDraftData({ id: docSnapshot.id, ...docSnapshot.data() });
          setNotFound(false);
        } else {
          console.log("No matching draft found");
          setDraftData(null);
          setNotFound(true);
        }
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching draft submission:", err);
        setDraftData(null);
        setNotFound(false);
        setError("Failed to fetch submission.");
        setLoading(false);
      }
    );

    // Clean up listener on unmount or submissionId change
    return () => unsubscribe();
  }, [submissionId]);

  return { draftData, loading, error, notFound };
};

export default useDraftSubmission;
